




















































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import _ from "lodash";
import moment from "moment";

import ViewActivation from "./view-activation.vue";
import UpdateActivation from "./update-activation.vue";
import DeactivateActivations from "./deactivate-activation.vue";

class PageWarrantyActivationRequest extends PageRequest {
  mainSerialNo: string;
  hiddenCode: string;
  consumerPhone: string;
  fromDate: Date;
  toDate: Date;
}

@Component({
  components: {
    "view-detail": ViewActivation,
    deactivate: DeactivateActivations,
    update: UpdateActivation,
  },
})
export default class WarrantyActivation extends mixins(ListMixin, AbpBase) {
  namespace = "warrantyActivation";
  viewModalShow: boolean = false;
  editModalShow: boolean = false;
  deactivateModalShow: boolean = false;
  pagerequest: PageWarrantyActivationRequest = new PageWarrantyActivationRequest();
  creationTime: Date[] = [];
  selectedHiddenCode = "";
  selectedConsumerName = "";

  get store() {
    return this.$store.state.warrantyActivation;
  }
  get list() {
    var re = this.store.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  checkFilterCriteria() {
    if (
      _.isNil(this.pagerequest.mainSerialNo) &&
      _.isEmpty(this.pagerequest.mainSerialNo) &&
      _.isNil(this.pagerequest.hiddenCode) &&
      _.isEmpty(this.pagerequest.hiddenCode) &&
      _.isNil(this.pagerequest.consumerPhone) &&
      _.isEmpty(this.pagerequest.consumerPhone)
    ) {
      Util.showErrorMsg(this, "Error.RequireFilterCriteria");
      return false;
    }
    if (
      (!_.isNil(this.pagerequest.mainSerialNo) &&
        !_.isEmpty(this.pagerequest.mainSerialNo) &&
        this.pagerequest.mainSerialNo.length < 8) ||
      (!_.isNil(this.pagerequest.hiddenCode) &&
        !_.isEmpty(this.pagerequest.hiddenCode) &&
        this.pagerequest.hiddenCode.length < 8)
    ) {
      Util.showErrorMsg(
        this,
        Util.L(
          "Error.InvalidObject",
          undefined,
          `${Util.L("MainSerialNo")}/${Util.L("HiddenCode")}`
        )
      );

      return false;
    }
    if (
      !_.isNil(this.pagerequest.consumerPhone) &&
      !_.isEmpty(this.pagerequest.consumerPhone) &&
      this.pagerequest.consumerPhone.length < 10
    ) {
      Util.showErrorMsg(
        this,
        Util.L("Error.InvalidObject", undefined, Util.L("ConsumerPhone"))
      );

      return false;
    }
    return true;
  }
  preGetPage() {
    this.pagerequest.fromDate = null;
    this.pagerequest.toDate = null;
    if (
      this.creationTime.length > 0 &&
      !_.isNil(this.creationTime[0]) &&
      this.creationTime[0].toString() !== ""
    ) {
      this.pagerequest.fromDate = moment(this.creationTime[0])
        .startOf("d")
        .toDate();
    }
    if (
      this.creationTime.length > 1 &&
      !_.isNil(this.creationTime[1]) &&
      this.creationTime[1].toString() !== ""
    ) {
      this.pagerequest.toDate = moment(this.creationTime[1])
        .endOf("d")
        .toDate();
    }
  }
  async getpage() {
    if (this.checkFilterCriteria()) {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
      this.preGetPage();
      await this.$store
        .dispatch({
          type: `${this.namespace}/getAll`,
          data: this.pagerequest,
        })
        .finally(() => {
          this.store.loading = false;
        });
    }
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: `${this.namespace}/export`,
      data: this.pagerequest,
    });
  }
  reset() {
    this.pagerequest = new PageWarrantyActivationRequest();
    var defaultDate = new Date();
    var defaultDateFrom = moment()
      .add(-7, "d")
      .toDate();
    this.creationTime = [defaultDateFrom, defaultDate];
  }
  viewDetail(row) {
    this.viewModalShow = true;
    this.selectedHiddenCode = row.hiddenCode;
  }
  update(row) {
    this.editModalShow = true;
    this.selectedHiddenCode = row.hiddenCode;
  }
  deactivate(row) {
    this.deactivateModalShow = true;
    this.selectedHiddenCode = row.hiddenCode;
    this.selectedConsumerName = row.consumerName;
  }
  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
      fixed: "left",
    },
    {
      title: Util.L("HiddenCode"),
      width: 150,
      slot: "hiddenCode",
      fixed: "left",
    },
    {
      title: Util.L("SKU"),
      width: 150,
      key: "product.sku",
      fixed: "left",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.sku);
      },
    },
    {
      title: Util.L("ProductName"),
      width: 200,
      key: "product.name",
      fixed: "left",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.name);
      },
    },
    {
      title: Util.L("BrandName"),
      width: 150,
      key: "product.brandName",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.product)) return "";
        return h("span", params.row.product.brandName);
      },
    },
    {
      title: Util.L("ExportBrandName"),
      width: 120,
      key: "exportBrandName",
    },
    {
      title: Util.L("Distributor"),
      width: 150,
      key: "distributor.id",
      render: (h: any, params: any) => {
        if (_.isNil(params.row.distributor)) return "";
        return h("span", params.row.distributor.name);
      },
    },
    {
      title: Util.L("Seller"),
      width: 150,
      key: "salesmanName",
    },
    {
      title: Util.L("ActivatorName"),
      width: 150,
      key: "activatorName",
    },
    {
      title: Util.L("ConsumerName"),
      width: 150,
      key: "consumerName",
    },
    {
      title: Util.L("ConsumerPhone"),
      width: 150,
      key: "maskConsumerPhone",
    },
    {
      title: Util.L("ConsumerFullAddress"),
      width: 150,
      key: "consumerFullAddress",
    },
    {
      title: Util.L("ConsumerIdentityCard"),
      width: 150,
      key: "consumerIdentityCard",
    },
    {
      title: Util.L("ConsumerProvinceId"),
      width: 150,
      key: "consumerProvinceName",
    },
    {
      title: Util.L("WarrantyActivateDate"),
      key: "warrantyActivateDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.warrantyActivateDate)) return "";
        return h(
          "span",
          Util.toViewDatePickerString(params.row.warrantyActivateDate)
        );
      },
    },
    {
      title: Util.L("StampActivateDate"),
      key: "stampActivateDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.stampActivateDate)) return "";
        return h(
          "span",
          Util.toViewDatePickerString(params.row.stampActivateDate)
        );
      },
    },
    {
      title: Util.L("OutboundDate"),
      key: "outboundDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.outboundDate)) return "";
        return h("span", Util.toViewDatePickerString(params.row.outboundDate));
      },
    },
    {
      title: Util.L("WarrantyDate"),
      key: "warrantyDate",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.warrantyDate)) return "";
        return h("span", Util.toViewDatePickerString(params.row.warrantyDate));
      },
    },
    {
      title: Util.L("ManufactureMonth"),
      key: "manufactureMonth",
      width: 150,
      render: (h: any, params: any) => {
        if (_.isNil(params.row.manufactureMonth)) return "";
        return h("span", Util.toMonthYearString(params.row.manufactureMonth));
      },
    },
    {
      title: Util.L("Action"),
      width: 120,
      fixed: "right",
      slot: "action",
      align: "center",
    },
  ];
  async created() {
    this.reset();
  }
}
